import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
import '@/assets/eas-theme.scss';
import '@/assets/design-system.scss';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'; // Import Element Plus styles

const app = createApp(App).use(ElementPlus).use(store).use(router);
app.mount('#app');
